/**
 * Art Department — collection catalogues.
 *
 * --- HOW TO ADD A NEW PAINTING TO "TALES OF HUMANITY AND TECHNOLOGY" -----
 *  1. Upload the image artifact (or place a JPG/PNG into
 *     /app/frontend/public/art/<slug>.jpg).
 *  2. Add a new entry to the TALES array below, in the order you want it
 *     to appear in the gallery:
 *
 *      {
 *        id: "your-piece-slug",                  // unique, used in DB likes/comments
 *        title: "Your Title",
 *        description: "One-sentence description.",
 *        src: "/art/your-slug.jpg" OR full URL,
 *        alt: "Short alt-text for accessibility",
 *      }
 *
 *  3. That's it. Likes, comments and lightbox navigation pick the new piece
 *     up automatically. The "Most loved" badge is computed at runtime from
 *     real like counts in MongoDB.
 *
 *  --- HOW TO ADD AN ENTIRELY NEW COLLECTION ------------------------------
 *  Add a new exported array (e.g. `export const ECHOES = [...]`) and create
 *  a feed page that imports it. The TalesFeed component is generic enough
 *  to be reused by passing a different array.
 */

export const TALES = [
  {
    id: "cosmicos",
    title: "Cosmicos",
    description:
      "Embarking on a voyage into the unknown, carrying only love, curiosity, and a resilient mind as your baggage.",
    src: "https://customer-assets.emergentagent.com/job_silent-expensive/artifacts/406ar66i_20250712_173639.jpg",
    alt: "Two figure-trees, one with a camera mask",
  },
  {
    id: "lighting-up-imaginarium",
    title: "Lighting up Imaginarium",
    description: "Standing at the precipice, we must forge ahead.",
    src: "https://customer-assets.emergentagent.com/job_silent-expensive/artifacts/iv0s9dpg_20250805_113210.jpg",
    alt: "Figure holding a silver sphere overhead",
  },
  {
    id: "silicon-feathers",
    title: "Silicon Feathers",
    description:
      "Heavy is the head that wears the crown. Nature and silicon should not compete, but rather work in unison.",
    src: "https://customer-assets.emergentagent.com/job_silent-expensive/artifacts/kquhai9l_20250712_173716.jpg",
    alt: "Pink figure with a golden halo, arms crossed",
  },
  {
    id: "mother-of-beans",
    title: "Mother of Beans",
    description: "That majestic feeling of home.",
    src: "https://customer-assets.emergentagent.com/job_silent-expensive/artifacts/p8cuesu6_20251112_173118.jpg",
    alt: "Green-haired figure cradling a wooden vessel of beans",
  },
];

export default TALES;
